export const PERIODS = ['Month', 'Quarter', 'Half year'];

export const getOption = text => ({
	label: text,
	value: text,
});

export const DATE_API_FORMAT = 'YYYY-MM-DDTHH:mm:ss';

export const deviceScale = window.devicePixelRatio;

export const MONTH_DAY_WIDTH = 6;
export const QUARTER_DAY_WIDTH = 3;
export const HALF_YEAR_DAY_WIDTH = 2;
export const DAYS_IN_WEEK = 7;

export const WAVE_PANELS_MARGIN = 24;
export const INITIATIVE_HEIGHT = 24;
export const INITIATIVE_MARGIN = 8;

export const PLAN_AND_TRACK_NAV_CONFIG = [
	{
		name: 'Initiatives',
		label: 'Initiatives',
		path: '/initiatives/categories',
	},
	{
		name: 'waves',
		label: 'Wave Planning',
		path: '/waves',
	},
	{
		name: 'savings-tracker',
		label: 'Savings Tracker',
		path: '/budget',
	},
];
